import cx from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';

import {
	Brands,
	Business,
	ContentLayout,
	Development,
	Management,
	OurMission,
	QuickBottomNavigationWrapper,
} from '../../components';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import styles from '../../stylesheets/pages/about-us.module.scss';

const AboutUs = () => {
	const data = useStaticQuery(graphql`
		{
			contentfulOurMission {
				mobileBackgroundImage {
					fluid(maxWidth: 860, quality: 100) {
						...GatsbyContentfulFluid
					}
				}
				backgroundImage {
					fluid(maxWidth: 2550, quality: 100) {
						...GatsbyContentfulFluid
					}
				}
			}
		}
	`);
	const { backgroundImage, mobileBackgroundImage } = data.contentfulOurMission;
	return (
		<Layout>
			<SEO title="About us" />
			<QuickBottomNavigationWrapper>
				<section className={styles.section}>
					<div className={styles.desktop}>
						<div className={styles.imgWrapperDesktop}>
							<Img fluid={backgroundImage.fluid} />
						</div>
						<ContentLayout>
							<OurMission />
						</ContentLayout>
					</div>
					<div className={styles.mobile}>
						<div className={styles.imgWrapperMobile}>
							<Img fluid={mobileBackgroundImage.fluid} />
						</div>
						<ContentLayout>
							<OurMission />
						</ContentLayout>
					</div>
				</section>
				<section className={styles.section}>
					<ContentLayout>
						<Business />
					</ContentLayout>
				</section>
				<section className={styles.section}>
					<ContentLayout>
						<Development />
					</ContentLayout>
				</section>
				<section className={styles.section}>
					<ContentLayout>
						<Brands />
					</ContentLayout>
				</section>
				<section className={styles.section}>
					<ContentLayout>
						<Management />
					</ContentLayout>
				</section>
			</QuickBottomNavigationWrapper>
		</Layout>
	);
};

export default AboutUs;
